<template>
  <section class="guide">
    <h3>{{ $t('message.guide') }}</h3>
    <article class="article" v-for="(article, index) of articles" :key="index">
      <h4>{{ article[$i18n.locale].title }}</h4>
      <div v-html="article[$i18n.locale].content" />
    </article>
  </section>
</template>

<script>
import { articles }from 'ncovjp-data/articles.json'

const GUIDE_ARTICLE_CATEGORY = 'guide'
const guideArticles = articles.filter(({ category }) => category === GUIDE_ARTICLE_CATEGORY)

export default {
  name: 'Guide',
  data () {
    return {
      articles: guideArticles,
    }
  },
  components: {
  },
}
</script>

<style lang="less" scoped>
.guide {
  padding: 0 24px;
  border-bottom: 1px solid #f9f9f9;
  h3 {
    color: #333;
    font-size: 24px;
    font-weight: bold;
    line-height: 1em;
    margin: 1.5em 0;
    padding: 0;
  }
}
</style>

<style lang="less">
.article {
  text-align: left;
  font-size: 14px;
  line-height: 1.4em;
  color: #555;
  margin-bottom: 4em;
  h4 {
    font-size: 16px;
    font-weight: bold;
    border-left: 4px solid #333;
    color: #333;
    padding-left: 0.5em;
    margin: 1em 0;
  }
  ul {
    padding: 0 0 0 2em;
  }
  li {
    padding: 0.5em 0;
  }
  a {
    color: #555;
    text-decoration: underline;
  }
  p {
    line-height: 1.4em;
    margin: 1em 0;
    padding: 0;
  }
}
</style>
